module.exports = __webpack_public_path__ + "static/media/close_icon.6df048d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_icon.svg
// module id = 16
// module chunks = 0